export const ReportingIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 16}
      height={size || 16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M6 3h8l4 4v14H6z"></path>
      <path d="M14 3v4h4"></path>
      <line x1="9" y1="13" x2="15" y2="13"></line>
      <line x1="9" y1="16.5" x2="15" y2="16.5"></line>
    </svg>
  );
};
